module.exports = __webpack_public_path__ + "static/media/hexagon.01c5e92e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/form/Type/hexagon.svg
 ** module id = 192
 ** module chunks = 0
 **/